import React, { useRef } from 'react';

/**
 * Retains a section's React tree across route changes (display toggle only).
 * First `children` mount is cached; later prop changes do not replace the tree.
 */
export default function SectionKeepAlive({ name, active, enabled, children }) {
  const cacheRef = useRef(new Map());

  if (enabled && children && !cacheRef.current.has(name)) {
    cacheRef.current.set(name, children);
  }

  const cached = cacheRef.current.get(name);
  if (!cached) return null;

  return (
    <div
      data-retained-section={name}
      data-retained-active={active ? '1' : '0'}
      style={{
        display: active ? 'block' : 'none',
        height: active ? undefined : 0,
        overflow: active ? undefined : 'hidden',
        visibility: active ? 'visible' : 'hidden',
        pointerEvents: active ? 'auto' : 'none',
      }}
      aria-hidden={!active}
    >
      {cached}
    </div>
  );
}
